import http from './../../../base/api/public'
import {requestPostFile, requestPutFile, fileDownload} from '@/common/fileUtil.js'

let service = require('@/../config/serviceList')
let sysConfig = require('@/../config/sysConfig')
let apiPre = sysConfig.apiPre
export default {
  getPage(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.member + '/member/operator/page', params)
  },
  delete(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestDelete(apiPre + service.member + '/member/operator/deleteById/' + params, {})
  },
  getDtoById(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestGet(apiPre + service.member + '/member/operator/getDtoById/' + params, {})
  },
  getDetailById(params) {
    return http.requestGet(apiPre + service.member + '/member/operator/getDetailById/' + params, {})
  },
  insert(params) {
    return requestPostFile(apiPre + service.member + '/member/operator/insert', params)
  },
  update(params) {
    return requestPutFile(apiPre + service.member + '/member/operator/update', params)
  },
  joinAdd(params) {
    return requestPostFile(apiPre + service.member + '/member/operator/joinAdd', params)
  },
  joinUpdate(params) {
    return requestPutFile(apiPre + service.member + '/member/operator/joinUpdate', params)
  },
  setPaymentType(params) {
    return http.requestPostKeyValue(apiPre + service.member + '/member/operator/insertBatch', params)
  },
  fileDownload() {
    fileDownload(apiPre + service.member + '/member/operator/fileDownload', {type: 'sieyuan'})
  },
  enableOrNot(operator) {
    return http.requestPost(apiPre + service.member + '/member/operator/enableOrNot', operator)
  },
  checkSubmit(check, operator) {
    return http.requestPost(apiPre + service.member + '/member/operator/check/' + check, operator)
  },
  getOperatorTree() {
    return http.requestPost(apiPre + service.member + '/member/operator/operatorTree', {})
  },
  getOperatorList(operator = {}) {
    return http.requestPost(apiPre + service.member + '/member/operator/getList', operator)
  },
  getMerchantByOperatorId(id) {
    return http.requestPost(apiPre + service.member + '/member/operator/getByOperatorId/' + id, {})
  },
  getOperatorPayType(id) {
    return http.requestPost(apiPre + service.member + '/member/operator/listPaymentTypeByOperatorId/' + id, {})
  }
}



// WEBPACK FOOTER //
// ./src/module/memberCenter/api/operator.js